import "core-js/stable";
import "regenerator-runtime/runtime";

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initErrorReporter } from "./errorReport.ts";

// import("@welldone-software/why-did-you-render").then(
//   ({ default: whyDidYouRender }) => {
//     whyDidYouRender(React, {
//       trackAllPureComponents: true,
//       trackHooks: true,
//       logOnDifferentValues: true,
//     });
//   }
// );
// تحسين الأداء العام
const initializeApp = () => {
  if (import.meta.env.VITE_ENV !== "development") initErrorReporter();

  const root = document.getElementById("root");
  if (!root) throw new Error("Root element not found");

  // تحسين React concurrent features
  const reactRoot = createRoot(root);

  reactRoot.render(<App />);
};

// // تأخير قصير للسماح بتحميل الصفحة
// requestIdleCallback ?
//   requestIdleCallback(initializeApp) :
//   setTimeout(initializeApp, 0);

initializeApp();
